export default "/images/a567786e233fcc0f8ce44a2ff7427404.avif";